<template>
  <div id="app" @click="toPlay">
    <audio
      id="cheerMusic"
      ref="music"
      autoplay="autoplay"
      loop="loop"
      hidden="true"
      preload
      controls
      :src="require('../static/music.mp3')"
    ></audio>
    <router-view />
  </div>
</template>

<script>
var wx = require("weixin-js-sdk");
import { getWxConfig } from "@/api/apiData";
export default {
  name: "app",
  mounted() {
    // 播放音乐
    this.autoPlayAudio();
  },
  methods: {
    toPlay() {
      this.autoPlayAudio();
    },
    autoPlayAudio() {
      var globalAudio = document.getElementById("cheerMusic");
      globalAudio.play();
      const that = this;
      getWxConfig({}, false).then((res) => {
          that.wechatShare2(res.data);
      });
    },
    // 分享设置
    wechatShare2(data) {
      var appId = data.appId;
      var timestamp = data.timestamp;
      var nonceStr = data.nonceStr;
      var signature = data.signature;
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        wx.config({
          debug: data.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appId, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名，见附录1
          jsApiList: data.jsApiList
        });
        wx.ready(function () {
          var globalAudio = document.getElementById("cheerMusic");
          globalAudio.play();
        });
      }
    },
  },
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
body,
html {
  height: 100%;
  overflow: hidden;
}
img {
  image-rendering: -moz-crisp-edges; /* Firefox */
  image-rendering: -o-crisp-edges; /* Opera */
  image-rendering: -webkit-optimize-contrast; /*Webkit (non-standard naming) */
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
}
.logo {
  position: fixed;
  top: 3vw;
  left: 5vw;
  width: 50%;
  z-index: 10;
}
</style>




// WEBPACK FOOTER //
// src/App.vue